import React from 'react';

const Darkmode = () => {
    const switchTheme = (e) => {
        document.querySelector('body').classList.toggle("light")
    }
    return (
        <div className='d-flex'>
            <button id="darkmode" onClick={(e) => switchTheme(e)}>
               <img className="light-icon" src={`${process.env.PUBLIC_URL}/images/icons/sun-01.svg`} alt="Sun images" />
               <img className="dark-icon" src={`${process.env.PUBLIC_URL}/images/icons/vector.svg`} alt="Sun images" />
            </button>
         
        </div>
    )
    //  replace above <Link to="/login"><button id="darkmode" style={{color:"white",fontSize:"16px"}}><FiUser/></button></Link>
}
export default Darkmode;